<template>
  <div v-cloak>
    <div @click="$emit('click')">
      <!-- Volume High -->
      <svg v-if='volume==3' class="volume" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="40" stroke-linecap="round" stroke-linejoin="round">
        <path d="M256 128 L160 196 H80 V316 H160 L256 384 Z" stroke-linejoin="round"/>
        <path d="M320 224 Q358 256 320 288"/>
        <path d="M362 192 Q420 256 362 320"/>
        <path d="M404 160 Q478 256 404 352"/>
      </svg>
      <!-- Volume Medium -->
      <svg v-else-if='volume==2' class="volume" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="40" stroke-linecap="round" stroke-linejoin="round">
        <path d="M256 128 L160 196 H80 V316 H160 L256 384 Z" stroke-linejoin="round"/>
        <path d="M320 224 Q358 256 320 288"/>
        <path d="M362 192 Q420 256 362 320"/>
      </svg>
      <!-- Volume Low -->
      <svg v-else-if='volume==1' class="volume" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="40" stroke-linecap="round" stroke-linejoin="round">
        <path d="M256 128 L160 196 H80 V316 H160 L256 384 Z" stroke-linejoin="round"/>
        <path d="M320 224 Q358 256 320 288"/>
      </svg>
      <!-- Mute -->
      <svg v-else class="volume" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="40" stroke-linecap="round" stroke-linejoin="round">
        <path d="M256 128 L160 196 H80 V316 H160 L256 384 Z" stroke-linejoin="round"/>
        <line x1="320" y1="208" x2="432" y2="320"/>
        <line x1="432" y1="208" x2="320" y2="320"/>
      </svg>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'volume',
    emits:['click'],
    props: {
      volume:Number,
    },
    data() {
      return {
      }
    },
    computed: {
    },
    methods: {
    },
    watch: {
    },
    mounted() {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.volume {
  width: 3vh;
  height: 3vh;
  display: block;
}
</style>
